import React from "react";
import type { ComponentMessageType } from "../../../types/ComponentMessageType";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import styles from "../message.module.scss";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import type { TuvisIconNamesType } from "@whatslly/types/UI-V2/BaseElements/Svg/TuvisIconNamesType";
export type MessageFloatingActionType = {
  tooltip: string;
  permission?: boolean;
  onClick: (message: ComponentMessageType) => void;
  testId?: string;
} & ({ iconName?: undefined; icon: React.ReactNode } | { iconName: TuvisIconNamesType; icon?: undefined });

const FloatingAction: React.FC<MessageFloatingActionType & { message: ComponentMessageType }> = React.memo(
  ({ iconName, tooltip, permission, onClick, message, icon, testId }) => {
    const show = permission === undefined || permission;
    const iconToRender = iconName ? <SvgV2 iconName={iconName} height={12} width={12} /> : icon;
    if (!show) return <></>;
    return (
      <Tooltip value={<span>{tooltip}</span>} disabled={!tooltip}>
        <div className={styles.messageFloatingAction} onClick={() => onClick?.(message)} data-testid={testId}>
          {iconToRender}
        </div>
      </Tooltip>
    );
  }
);

export const FloatingActions: React.FC<{
  message: ComponentMessageType;
  floatingActions: [MessageFloatingActionType] | [MessageFloatingActionType, MessageFloatingActionType] | undefined;
}> = React.memo(({ message, floatingActions }) => {
  const noActions = !floatingActions || floatingActions.findIndex((action) => action.permission === undefined || action.permission) === -1;
  if (noActions) return <></>;
  return (
    <div className={styles.messageFloatingActions}>
      {floatingActions.map((action, key) => (
        <FloatingAction {...action} message={message} key={`${action.tooltip}-${key}`} testId={`floating-action-${message.id}-${key}`} />
      ))}
    </div>
  );
});
